import Select from './Select';
export default Select;
export type { SelectTypes } from './Select.types';

export const Select_Query = `
  _type == "Select" => {

  },
`;